import React from "react";
import { Grid } from "@mui/material";

import {
  formatMonetary,
  timeStampToDate,
  formatUpperCase,
} from "../../../../utils/formats";
import Table from "../../subcomponents/Table";

const style = {
  justify: "center",
};

const columns = [
  { id: "id", name: "Nº da proposta", style },
  { id: "id", name: "Data", render: timeStampToDate, style },
  { id: "id", name: "Valor", render: formatMonetary, style },
  {
    id: "id",
    name: "parcela",
    render: (value, id, entry) =>
      `${entry.numeroParcelas || 0} x ${formatMonetary(entry.valorParcela)}`,
    style,
  },
  { id: "id", name: "Pedido", render: formatUpperCase, style },
  { id: "id", name: "Situação", render: formatUpperCase, style },
  { id: "id", name: "Status", render: formatUpperCase, style },
];

const HistoricoPropostasContratosSection = (props) => {
  // const {aggregatesLoading, aggregates} = props;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Table
            loading={false}
            noDataMessage="SEM DADOS."
            entries={[]}
            columns={columns}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default HistoricoPropostasContratosSection;
